const mutations = {
  getAboutUsBanner: (state, aboutus_banner) => {
    state.aboutus_banner = aboutus_banner;
  },
  // postPaxelcoDashboard: (state, new_paxel_dashboard) => {
  //   state.paxel_dashboard.push(new_paxel_dashboard);
  // },
};

export default mutations;